import { Grid, Skeleton, Typography } from "@mui/material";
import { Container } from "@mui/system";
import axios from "axios";
import React, { useEffect, useState } from "react";
import PostCard from "./PostCard";

export default function MorePosts({currentPost}){

    const [posts, setPosts]=useState();

    //Fetch posts
    useEffect(()=>{
        if(currentPost){
            axios.get(
                WP_API_Settings.endpoint+'wp/v2/posts'+
                '?exclude='+currentPost+
                '&categories_exclude=28'+
                '&per_page=3'+
                '&_embed=true'+
                '&acf_format=standard'
            ).then((response)=>{
                setPosts(response.data);
            });
        }
    },[currentPost]);

    //console.log(posts)

    return(
        <Container maxWidth='xl'
            sx={{
                m:'3rem auto'
            }}
        >
            <Typography variant='h3'
				sx={{
					mb:'2rem',
					fontSize:'1.6rem',
					color:'#005EAA'
				}}
			>
                Other Insights you may be interested in
            </Typography>
            <Grid container spacing={2}>
                {posts?
                    posts.map((post)=>{
                        return(
                            <Grid item xs={12} md={4}>
                                <PostCard
                                    post={post}
                                />
                            </Grid>
                        );
                    })
                :
                    Array(3).fill(0).map(()=>{
                        return(
                            <Skeleton variant='rectangular' height={400}/>
                        );
                    })
                }
            </Grid>
        </Container>
    );
}